import {Component, Input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {ModalController} from '@ionic/angular';
import {WheelGameSliceTypeList} from '../../../../../core-logic/models/wheel-game/wheel-game-model';

@Component({
  selector: 'app-wheel-slice-type-modal',
  templateUrl: './wheel-slice-type-modal.component.html',
  styleUrls: ['./wheel-slice-type-modal.component.scss'],
})
export class WheelSliceTypeModalComponent {
  @Input() sliceTypeCtrl: FormControl;
  constructor(
    private modalCtrl: ModalController
  ) {}

  get wheelGameSliceTypeList() {return WheelGameSliceTypeList }

  async closeModal() {
    await this.modalCtrl.dismiss();
  }
}
